import trackGoogleEvent from "CommonScripts/googleanalytics";
import ctaEventDataLayer from "CommonScripts/ctaEvents";

(() => {
  setTimeout(() => {
    if (window.dataLayer && window[0]) {
      let pageType = window.dataLayer.push({
        event: "quality_visit",
        page_type: window.dataLayer[0].page_type
      });
    }
  }, 30000);
})();

let callback = function () {
  let addExternalAttributeOnExternalLinks = () => {
    let currentDomain =
      document.location.protocol + "//" + document.location.hostname,
      outboundLinks = 'a[href^="http"]:not([href^="' + currentDomain + '"])';

    document.querySelectorAll(outboundLinks).forEach(element => {
      if (element.attributes.external === undefined) {
        element.attributes.external = "";
      }
    });
  };
  addExternalAttributeOnExternalLinks();

  // Attach tracking event to the click on all links that have the external attribute
  let anchorExternal = document.querySelectorAll("a[external]");
  anchorExternal.forEach(anchor => {
    anchor.addEventListener("click", () => {
      trackGoogleEvent("External links", anchor.hostname, anchor.href, false);
    });
  });

  // Add Event to download click
  const downloadLinks = document.querySelectorAll(
    "a[media],[href*='pdf'],[href*='.pdf'],[href*='.zip'],[href*='.doc'],[href*='.docx'],[href*='.ppt'],[href*='.pptx'],[href*='.xls'],[href*='.xlsx'],a[href^='https://contenthub.velux.com'],a[href^='https://weshare.velux.com'],a[href^='https://velcdn.azureedge.net']"
  );
  downloadLinks.forEach(link => {
    link.addEventListener("click", () => {
      const fileCategory = link.textContent.trim();
      const fileName = link.href.split("/").pop().replace(/\.[^.]+$/, "");
      trackGoogleEvent({ event: "download_file", file_category: fileCategory, file_name: fileName, link_url: link.href });
    });
  });

  // Add tracking events to all links in the MegaMenu
  let menuLinks = document.querySelectorAll(
    ".big-menu a:not(.search-button), .mobile-menu a:not(.search-button)"
  );
  menuLinks.forEach(menuLink => {
    menuLink.addEventListener("click", () => {
      trackGoogleEvent("Mega menu", "Click", menuLink.text, false);
      ctaEventDataLayer(menuLink, "");
    });
  });

  // Add tracking event to the search (searching for ...) in the MegaMenu
  let searchBtn = document.querySelector(".big-menu .search-button"),
    searchBox = searchBtn ? searchBtn.closest(".search-box") : null,
    searchInput = searchBox
      ? searchBox.querySelector(".search-field input")
      : null;

  if (searchInput) {
    searchBtn.addEventListener("click", () => {
      trackGoogleEvent("Mega menu", "Search", searchInput.value, false);
    });
  }

  // Add tracking to the Accordion-tabs
  let accordionTabs = document.querySelectorAll(".accordion-tab");
  accordionTabs.forEach((tab, index) => {
    tab.addEventListener("click", () => {
      let accordionSelector = tab.closest(".accordion-selector");
      let accordionSelectorNew = tab.closest(".vlx-wrapper");
      let numberInList = index + 1;

      let eventCategory =
        accordionSelector &&
          accordionSelector.querySelector(".header-title-selector")
          ? accordionSelector
            .querySelector(".header-title-selector")
            .innerText.trim()
          : undefined;

      if (
        accordionSelector &&
        accordionSelector.querySelector(".header-title-selector")
      ) {
        eventCategory =
          accordionSelector &&
          accordionSelector
            .querySelector(".header-title-selector")
            .innerText.trim();
      } else if (
        accordionSelectorNew &&
        accordionSelectorNew.querySelector("h2")
      ) {
        eventCategory = accordionSelectorNew
          .querySelector("h2")
          .innerText.trim();
      }

      let eventAction = tab.querySelector(".tab-title")
        ? tab.querySelector(".tab-title").innerText
        : undefined;

      if (eventAction) {
        trackGoogleEvent(eventCategory, eventAction, numberInList, false);
      }
    });
  });

  // Tracking on the Anchor-Menu
  let anchorMenus = document.querySelectorAll(".anchormenu a");
  anchorMenus.forEach(menu => {
    menu.addEventListener("click", () => {
      trackGoogleEvent("Sub Mega Menu", "Navigate", menu.innerText, false);
    });
  });
};

if (
  document.readyState === "complete" ||
  (document.readyState !== "loading" && !document.documentElement.doScroll)
) {
  callback();
} else {
  document.addEventListener("DOMContentLoaded", callback);
}
